import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

const FN_LOGO =
  "https://customer-assets.emergentagent.com/job_premium-makhana-11/artifacts/4l1hs9ak_FN%20Logo%20%281%29.png";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Products", href: "#products" },
  { label: "About", href: "#about" },
  { label: "Value Add", href: "#value-add" },
  { label: "Distributor", href: "#distributor" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/95 backdrop-blur-lg shadow-[0_2px_30px_rgba(0,0,0,0.8)] border-b border-white/5"
          : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo & Brand */}
          <button
            onClick={() => scrollTo("#home")}
            className="flex items-center gap-3 group"
            data-testid="navbar-brand"
          >
            <img
              src={FN_LOGO}
              alt="New Foxnourish Logo"
              className="h-12 w-12 rounded-full shadow-[0_0_15px_rgba(212,175,55,0.3)] group-hover:shadow-[0_0_25px_rgba(212,175,55,0.5)] transition-all duration-300"
              data-testid="navbar-logo"
            />
            <div className="flex flex-col leading-tight">
              <span
                className="text-[#D4AF37] font-bold text-xl tracking-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                MakhanaG
              </span>
              <span className="text-[#525252] text-[10px] uppercase tracking-[3px]">
                by New Foxnourish
              </span>
            </div>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-7" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.href)}
                className="text-[#A1A1AA] hover:text-[#D4AF37] text-sm font-medium transition-colors duration-300 relative group"
                data-testid={`nav-${link.label.toLowerCase().replace(" ", "-")}`}
              >
                {link.label}
                <span className="absolute -bottom-0.5 left-0 w-0 h-[1px] bg-[#D4AF37] group-hover:w-full transition-all duration-300" />
              </button>
            ))}
            <a
              href="tel:+919502343899"
              className="hidden lg:flex items-center gap-2 text-[#A1A1AA] hover:text-[#D4AF37] text-sm transition-colors ml-2"
              data-testid="nav-phone"
            >
              <Phone size={13} />
              <span>+91-9502343899</span>
            </a>
            <button
              onClick={() => scrollTo("#distributor")}
              className="bg-[#D4AF37] text-black px-6 py-2.5 rounded-full text-sm font-bold hover:bg-[#F4E3B2] transition-all duration-300 shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_35px_rgba(212,175,55,0.5)] hover:scale-105"
              data-testid="nav-cta"
            >
              Enquire Now
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-[#D4AF37] p-2 rounded-lg hover:bg-[#D4AF37]/10 transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            menuOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          }`}
          data-testid="mobile-menu"
        >
          <div className="bg-[#121212] border-t border-[#D4AF37]/20 py-4 rounded-b-2xl">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollTo(link.href)}
                className="block w-full text-left px-5 py-3.5 text-[#A1A1AA] hover:text-[#D4AF37] hover:bg-[#D4AF37]/5 text-sm font-medium transition-all"
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(" ", "-")}`}
              >
                {link.label}
              </button>
            ))}
            <div className="px-5 pt-4 pb-2 border-t border-white/5 mt-2">
              <button
                onClick={() => scrollTo("#distributor")}
                className="w-full bg-[#D4AF37] text-black py-3.5 rounded-full text-sm font-bold hover:bg-[#F4E3B2] transition-all"
                data-testid="mobile-nav-cta"
              >
                Enquire Now
              </button>
              <a
                href="tel:+919502343899"
                className="flex items-center justify-center gap-2 mt-3 text-[#A1A1AA] text-sm"
                data-testid="mobile-nav-phone"
              >
                <Phone size={13} className="text-[#D4AF37]" />
                +91-9502343899
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
